import { RootState } from 'typesafe-actions';

export const getIsBot = ({ isBot }: RootState) => isBot;
